export default __webpack_public_path__ + "static/media/pauseAudio.f769d0db.svg";